/* @ngInject */
const local = (
  valueHandler,

  storageHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentRailwayId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentRailwayId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentRailwayId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/local.service.js